export const ROUTE_PATH = '/clean/owner/login' as const
